export default __webpack_public_path__ + "static/media/mercedes3.18e8a591.jpeg";